import get from 'lodash/get';

import { REDUCER_KEY } from './GuidedTour.reducer';

const getGuidedTourState = (store: any) => get(store, ['inventory', REDUCER_KEY], {});

export const isGuidedTourOpened = (store: any) => get(getGuidedTourState(store), 'isOpen', false);
